import AudienceLogic from '@/common/models/audience/AudienceLogic';
import API from '@/org-app/api';
import {
  createAuditAction,
  createDeleteAction,
  createGetAllAction,
  createGetOneAction,
  createPostAction,
  createPutAction,
} from '@/utils/ActionsUtils';

import * as types from './mutation-types';

export default {
  createNewAudienceLogic({ commit }, audienceLogic = AudienceLogic.fromObject({ name: '', description: '' })) {
    commit(types.CREATE_AUDIENCELOGIC, audienceLogic);
    return audienceLogic;
  },
  getAudienceLogics: createGetAllAction(
    API.instance.getAudienceLogics,
    types.UPDATE_AUDIENCELOGICS_LIST,
    'messages.failedToGetAudienceLogics',
    true,
  ),
  getAudienceLogic: createGetOneAction(
    API.instance.getAudienceLogic,
    types.SAVE_AUDIENCELOGIC,
    'messages.failedToGetAudienceLogic',
  ),
  createAudienceLogics: createPostAction(
    API.instance.postAudienceLogics,
    types.SAVE_AUDIENCELOGIC,
    'messages.failedToCreateAudienceLogic',
  ),
  createMastercardAudienceLogics: createPostAction(
    API.instance.postMastercardAudienceLogics,
    types.SAVE_AUDIENCELOGIC,
    'messages.failedToCreateAudienceLogic',
  ),
  updateAudienceLogic: createPutAction(
    API.instance.putAudienceLogic,
    types.SAVE_AUDIENCELOGIC,
    'messages.failedToUpdateAudienceLogic',
  ),
  deleteAudienceLogic: createDeleteAction(
    API.instance.deleteAudienceLogic,
    types.DELETE_AUDIENCELOGIC,
    'messages.failedToDeleteAudienceLogic',
  ),
  getAudienceLogicAudit: createAuditAction(
    API.instance.getAudienceLogicAudit,
    'messages.failedToGetAudienceLogicAudit',
  ),
};
